<script>
// https://medium.com/@dillonchanis/handling-errors-in-vue-with-error-boundaries-91f6ead0093b
export default {
  name: 'ErrorBoundary',
  data: () => ({
    error: false
  }),
  // vue passes here arguments - err, vm, info
  errorCaptured () {
    this.error = true;
  },
  render (h) {
    return this.error ? h('p', 'Something went wrong') : this.$slots.default[0];
  }
};
</script>